import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';

const SalesTeamListDetails = () => {
  const columns = [
    { label: 'Name', value: 'name' },
    { label: 'Team Lead', value: 'team_lead_name' },
    { label: 'Region', value: 'region_name' },
    { label: 'Members', value: 'member_names' },
    { label: 'Access Details', value: (id) => <button onClick={() => handleAccessDetails(id)}>Access Details</button> },
  ];
  const handleAccessDetails = (id) => {
    const encodedId = btoa(id);
    window.location.href = '/lead/sales-team/details/' + encodedId;
  };
  return <ListTemplate columns={columns} onAccessDetails={handleAccessDetails} fetchUrl={API_DOMAIN + API_ROUTES['salesTeam']} />;
};

export default SalesTeamListDetails;
